import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'kaz-button',
    templateUrl: './kaz-button.component.html',
    styleUrls: ['./kaz-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FaIconComponent]
})
export class KazButtonComponent {
  @Input('text') text: string = "";
  @Input('title') title: string = "";
  @Input('width') width: string = "100%";
  @Input('height') height: string = "3rem";
  @Input('icon') icon: IconProp | null = null;
  @Input('disabled') disabled: boolean = false;
  @Input('isLoading') isLoading: boolean = false;
  @Input() fileButton: boolean = false;


  @Input('buttonType') buttonType: 'primary'|'bordered'|'secondary'|'cookies' = 'primary';

  @Output('onClick') onClick: EventEmitter<void> = new EventEmitter<void>();
}
